import React from 'react'
import moment from 'moment'
import { Table } from 'antd-v4'
import { Link } from 'react-router'

export interface ISyncedJournalEntryResponse {
  journalEntryId: string
  date: string
}

interface IProps {
  appliedStartDate: string
  appliedEndDate: string
  syncedJournalEntries: ISyncedJournalEntryResponse[]
  sync: (date: string) => void
  remove: (date: string) => void
  isSyncing: boolean
}

interface IRecord {
  key: string
  date: string
  entry: ISyncedJournalEntryResponse | undefined
}

export const JournalEntriesTable = ({
  appliedEndDate,
  appliedStartDate,
  syncedJournalEntries,
  sync,
  remove,
  isSyncing,
}: IProps) => {
  const columns = [
    {
      title: 'Date',
      dataIndex: 'date',
      key: 'date',
      render: (date: string, record: IRecord) =>
        record.entry?.journalEntryId ? (
          <Link
            to={`https://app.sandbox.qbo.intuit.com/app/journal?txnId=${record.entry.journalEntryId}`}
            target='_blank'
          >
            {moment(date).format('MMM DD, YYYY')}
          </Link>
        ) : (
          moment(date).format('MMM DD, YYYY')
        ),
    },
    {
      title: 'Status',
      dataIndex: 'status',
      key: 'status',
      render: (nothing: undefined, record: IRecord) => (
        <span className={`mr-2 fa fa-circle ${record.entry ? 'text-success' : 'text-danger'}`} />
      ),
    },
    {
      title: 'Options',
      dataIndex: 'options',
      key: 'options',
      render: (options: undefined, record: IRecord) => (
        <>
          <button
            className={`btn btn-sm mr-2 'btn-light'`}
            style={{ width: '6em' }}
            onClick={() => sync(record.date)}
            disabled={isSyncing}
          >
            <i className='fa fa-refresh mr-2'></i>
            {record.entry?.journalEntryId ? 'Re-sync' : 'Sync'}
          </button>
          {record.entry?.journalEntryId && (
            <button
              className={`btn btn-sm mr-2 'btn-light'`}
              style={{ width: '6em' }}
              onClick={() => {
                if (
                  window.confirm('Are you sure? This will delete the record in QuickBooks Online.')
                ) {
                  remove(record.date)
                }
              }}
              disabled={isSyncing}
            >
              <i className='fa fa-remove mr-2'></i>
              Delete
            </button>
          )}
        </>
      ),
    },
  ]

  const dataSource = () => {
    const datesInMonth: string[] = []

    if (appliedStartDate && appliedEndDate) {
      const end = moment(appliedEndDate)
      for (
        const i = end;
        moment(appliedStartDate).format('YYYY-MM-DD') <= end.format('YYYY-MM-DD');
        end.subtract(1, 'day')
      ) {
        datesInMonth.push(end.format('YYYY-MM-DD'))
      }
    }
    return datesInMonth.map((date) => {
      const journalEntry = syncedJournalEntries.find((je) => je.date === date)

      return {
        key: date,
        date: date,
        entry: journalEntry,
      }
    })
  }

  return <Table pagination={false} dataSource={dataSource()} columns={columns} />
}
